import React from 'react';
// Zustand
import { useStore } from '../../zustand';
// Styles
import { makeStyles } from '@material-ui/core/styles';
import { billboardStyles } from "../../assets/jss/billboardStyles";
const useStyles = makeStyles(billboardStyles);

export default function AlternateSlider(props) {
    const [activeSlide, setActiveSlide] = React.useState(1);
    const { dynamic_text_settings } = useStore.getState().store_settings;
    const classes = useStyles(dynamic_text_settings);

    React.useEffect(() => {

        return;
    }, [activeSlide]);

    return(
        <div className={classes.features}>
            <div className={`${classes.feature} ${activeSlide === 1 ? 'active' : 'collapsed'}`}>
                <div className={classes.feature_media}>
                    <img src="https://d36txllq6xta93.cloudfront.net/images/keen/slider-img-1.jpg" alt="Feels like walking on air" />
                </div>
                <div className={classes.feature_text}>
                    <div className={classes.feature_title_wrap} onClick={() => {setActiveSlide(1)}}>
                        <h4 className={classes.feature_title}>Feels like walking on air.</h4>
                        <svg className={classes.feature_expand_icon} xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" fill="none" width="19" height="18" viewBox="0 0 19 18">
                          <path fillRule="evenodd" clipRule="evenodd" d="M8.01086 5V1H10.0109V5V7H8.01086L8.01086 5ZM17.0109 10H1.01086V8H17.0109V10ZM8 11V12V13L8 17H10V13V12V11H8Z" fill="currentColor"></path>
                        </svg>
                    </div>
                    <p className={classes.feature_copy}>KEEN Luftcell midsole is infused with nearly 100,000 micro air bubbles per cubic centimeter for all-day support.</p>
                </div>
            </div>
            <div className={`${classes.feature} ${activeSlide === 2 ? 'active' : 'collapsed'}`}>
                <div className={classes.feature_media}>
                    <img src="https://d36txllq6xta93.cloudfront.net/images/keen/slider-img-2.jpg" alt="Waterproof protection" />
                </div>
                <div className={classes.feature_text}>
                    <div className={classes.feature_title_wrap} onClick={() => {setActiveSlide(2)}}>
                        <h4 className={classes.feature_title}>Waterproof protection.</h4>
                        <svg className={classes.feature_expand_icon} xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" fill="none" width="19" height="18" viewBox="0 0 19 18">
                          <path fillRule="evenodd" clipRule="evenodd" d="M8.01086 5V1H10.0109V5V7H8.01086L8.01086 5ZM17.0109 10H1.01086V8H17.0109V10ZM8 11V12V13L8 17H10V13V12V11H8Z" fill="currentColor"></path>
                        </svg>
                    </div>
                    <p className={classes.feature_copy}>KEEN.DRY waterproof, breathable membrane keeps water out while allowing moisture to escape, providing dry comfort for your feet.</p>
                </div>
            </div>
            <div className={`${classes.feature} ${activeSlide === 3 ? 'active' : 'collapsed'}`}>
                <div className={classes.feature_media}>
                    <img src="https://d36txllq6xta93.cloudfront.net/images/keen/slider-img-3.jpg" alt="Low-profile versatility" />
                </div>
                <div className={classes.feature_text}>
                    <div className={classes.feature_title_wrap} onClick={() => {setActiveSlide(3)}}>
                        <h4 className={classes.feature_title}>Low-profile versatility.</h4>
                        <svg className={classes.feature_expand_icon} xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" fill="none" width="19" height="18" viewBox="0 0 19 18">
                          <path fillRule="evenodd" clipRule="evenodd" d="M8.01086 5V1H10.0109V5V7H8.01086L8.01086 5ZM17.0109 10H1.01086V8H17.0109V10ZM8 11V12V13L8 17H10V13V12V11H8Z" fill="currentColor"></path>
                        </svg>
                    </div>
                    <p className={classes.feature_copy}>Comfortable, flexible soft toes protect against minor impact and abrasion without providing a secondary source of crush resistance.</p>
                </div>
            </div>
        </div>
    )
}